// Noodle & Snoot: Geo/currency market suggestion pop-down.
// Added 13 August 2026. Isolated into its own asset file from the start
// (see Protected Custom Code Registry, item 6), so a future Dawn
// theme-engine update cannot silently strip it, only the small
// reference block in layout/theme.liquid could be lost, and that's
// trivial to restore.
//
// Uses Shopify's own browsing_context_suggestions.json Ajax API
// (https://shopify.dev/docs/storefronts/themes/markets/localization-discovery)
// to detect whether a visitor is likely in a different Shopify Market
// than the one currently active, then shows a dismissible pop-down
// suggesting a switch. Never auto-switches: Shopify's own guidance is
// explicit that GeoIP detection isn't perfect (VPNs etc.) and a visitor
// should never be silently redirected, only offered a choice.
//
// Country only, no language check: every market on this store (AU, NZ,
// UK, US, EU, Rest of World) serves English, so a language suggestion
// would never be useful here.
//
// Switching reuses the theme's own existing #HeaderCountryForm
// (rendered by sections/header.liquid via Shopify's {% form
// 'localization' %} tag). That form is always present in the DOM on
// every page load regardless of viewport, it's only visually hidden on
// small/medium screens via CSS, not removed. This is the exact same
// form and mechanism the visible header country selector already uses
// (see assets/localization-form.js's onItemClick handler: set the
// hidden country_code input's value, then call form.submit()), so
// switching via the pop-down behaves identically to a manual switch via
// the header dropdown, correct redirect-back behaviour included, with
// no need to reconstruct the POST by hand or guess at hidden fields.
//
// Dismiss is remembered indefinitely on that device via localStorage.
// Once dismissed, the pop-down never shows again on that device,
// regardless of what country gets suggested on a later visit.

(function () {
  var DISMISS_KEY = 'ns_geo_popdown_dismissed';

  function isDismissed() {
    try {
      return localStorage.getItem(DISMISS_KEY) === 'true';
    } catch (e) {
      return false; // localStorage unavailable; fail open (never shown, never remembered either way)
    }
  }

  function setDismissed() {
    try {
      localStorage.setItem(DISMISS_KEY, 'true');
    } catch (e) {
      /* ignore, nothing to persist to */
    }
  }

  function getCountryForm() {
    return document.getElementById('HeaderCountryForm');
  }

  function getCurrentCountryCode(form) {
    var input = form.querySelector('input[name="country_code"]');
    return input ? input.value : null;
  }

  function buildSuggestionsUrl(currentCountryCode) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    return root + 'browsing_context_suggestions.json' +
      '?country[enabled]=true' +
      '&country[exclude]=' + encodeURIComponent(currentCountryCode);
  }

  function switchCountry(countryHandle) {
    var form = getCountryForm();
    if (!form) {
      console.warn('Noodle & Snoot geo pop-down: #HeaderCountryForm not found, cannot switch.');
      return;
    }
    var input = form.querySelector('input[name="country_code"]');
    if (!input) {
      console.warn('Noodle & Snoot geo pop-down: country_code input not found on form.');
      return;
    }
    input.value = countryHandle;
    form.submit();
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function showPopdown() {
    var wrapper = document.getElementById('ns-geo-popdown');
    if (wrapper) wrapper.classList.add('ns-geo-popdown--visible');
  }

  function hidePopdown() {
    var wrapper = document.getElementById('ns-geo-popdown');
    if (wrapper) wrapper.classList.remove('ns-geo-popdown--visible');
  }

  function buildPopdown(suggestion) {
    var wrapper = document.getElementById('ns-geo-popdown');
    if (!wrapper) return;

    var countryName = suggestion.name;
    var countryHandle = suggestion.handle;

    wrapper.innerHTML =
      '<div class="ns-geo-popdown__inner">' +
        '<p class="ns-geo-popdown__text">Looks like you\'re shopping from ' + escapeHtml(countryName) + '. Switch to see local pricing and shipping?</p>' +
        '<div class="ns-geo-popdown__actions">' +
          '<button type="button" class="ns-geo-popdown__accept">Switch</button>' +
          '<button type="button" class="ns-geo-popdown__dismiss" aria-label="Dismiss">&times;</button>' +
        '</div>' +
      '</div>';

    wrapper.querySelector('.ns-geo-popdown__accept').addEventListener('click', function () {
      switchCountry(countryHandle);
    });

    wrapper.querySelector('.ns-geo-popdown__dismiss').addEventListener('click', function () {
      setDismissed();
      hidePopdown();
    });

    showPopdown();
  }

  function init() {
    if (isDismissed()) return;

    var form = getCountryForm();
    if (!form) return; // country selector disabled or not rendered, nothing to check against

    var currentCountryCode = getCurrentCountryCode(form);
    if (!currentCountryCode) return;

    fetch(buildSuggestionsUrl(currentCountryCode))
      .then(function (response) {
        if (!response.ok) throw new Error('Suggestions fetch failed');
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.detected_values || !data.detected_values.country) return;
        var detected = data.detected_values.country;
        // Belt-and-braces: the API already excludes the current country from
        // results, but don't show anything if it somehow matches anyway.
        if (detected.handle === currentCountryCode) return;
        buildPopdown(detected);
      })
      .catch(function (err) {
        console.warn('Noodle & Snoot geo pop-down: suggestion check failed.', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
